import { render, staticRenderFns } from "./FileDetailsModal.vue?vue&type=template&id=870fe328&"
import script from "./FileDetailsModal.vue?vue&type=script&lang=ts&"
export * from "./FileDetailsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports